// extracted by mini-css-extract-plugin
export default {"passwordPolicies":"thrqBWJI0KE_VcGlfc5x"};